import { handleColorTypes } from '@adaptiva/core/themes';
import { IGridStyle, IViewboxDotGridSettings } from '../interfaces';

export function viewboxDotGrid(_settings: IViewboxDotGridSettings): IGridStyle[] {
	const _backgroundColor: string = handleColorTypes(_settings.backgroundColor);
	const _gridColor: string = handleColorTypes(_settings.gridColor);

	const _style: IGridStyle[] = [
		{ style: 'background-color', value: `${_backgroundColor}` },
		{ style: 'background-image', value: `radial-gradient(circle, ${_gridColor} ${_settings.dotRadius}px, transparent ${_settings.dotRadius * 2}px)` },
	];

	return _style;
}

